import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';

import {
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getListStatus({ commit }, params) {
    return GraphQlClient.query(`
      query {
        trackingListStatus {
          value,
          label,
        }
      }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { trackingListStatus = [] } = data || {};

        commit('toggleLoading', false);
        commit('setListStatus', trackingListStatus);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  getlogsReverse({ commit }, params) {
    const {
      filters,
    } = params;
    const {
      logisticProviderId: logistic_provider_id,
      status,
      dateRange: date_range,
    } = filters;
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query(
        $logistic_provider_id: Int, 
        $status: String, 
        $date_range: DateRangeInput) {
        logsReverse(
          logistic_provider_id: $logistic_provider_id, 
          status: $status, 
          date_range: $date_range) {
          status,
          started,
          modified,
          message,
          retry_times,
          logistic_provider {
            name,
          },
        }
      }`, { logistic_provider_id, status, date_range })
      .then((res) => {
        const { data = {} } = res || {};
        const { logsReverse = [] } = data || {};

        commit('toggleLoading', false);
        commit('setlogsReverse', logsReverse);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  removelogsReverse({ commit }, id) {
    commit('toggleLoading', true);

    const params = {
      id,
    };

    return GraphQlClient.mutation(`
      mutation ($id: Int!){
        removelogsReverse(id: $id) {
          id
        }
      }`, params)
      .then((res) => {
        commit('toggleLoading', false);

        ScToast.success('Log de reversa removido com sucesso');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  exportlogsReverse({ commit }, params) {
    commit('toggleLoadingExport', true);

    return GraphQlClient.query(`
      query($field: String!){
        exportlogsReverse(field: $field) {
          id
        }
      }`, params)
      .then((res) => {
        commit('toggleLoadingExport', false);

        ScToast.success('logsReverse exportado com sucesso');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoadingExport', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/store/actions.js